import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=356e186e&scoped=true&"
var script = {}
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=356e186e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e186e",
  null
  
)

export default component.exports